import * as React from "react";
import { MapContainer } from "../components/mapContainer";
import "./index.scss";

var Index = function Index(_ref) {
  var data = _ref.data;
  var businesses = data ? data.prismic.allMap_datas.edges[0].node.businesses : [];
  return /*#__PURE__*/React.createElement(MapContainer, {
    businesses: businesses
  });
};

export default Index;
export var query = "3029418173";